<template>
  <div class="mainTranscritptContainer" @mouseover="scrollDesactivate=true"
       @mouseout="scrollDesactivate=false;">
    <perfect-scrollbar v-show="subtitleData.length>0" :options="{suppressScrollX:true}" ref="scrollPanel">
      <div class="transcriptLangContainer">
        <div class="chooseLang">
          <w-select :label="$t('transcript.lang')" :value="subtitleLang" @input="changeLang" size="small">
            <option :value="sub.lang" v-for="sub of weet.subtitles"
                    :key="sub.lang+sub.subtitleID">{{ sub.label }}
            </option>
          </w-select>
        </div>

        <div class="createTrancript" v-if="canEditThisWeet">

          <GoToSubtitleWeetButton size="small" :tooltip="$t('transcript.create.tooltip')" icon="pencil"
                                  color="outlined" :weet="weet">
          </GoToSubtitleWeetButton>
        </div>
      </div>
      <div class="blockTranscriptContainer" :class="'modeSub'">
        <div class="subtitleElement"
             :class="classSubtitle(subtitleLine.startTime)"
             @click="setPlayerTime(subtitleLine.startTime)"
             v-for="(subtitleLine,index) in subtitleData"
             :key="'subtitleLine'+index"
             :ref="'subtitle_'+(subtitleLine.startTime)">
            <span class="timeBox">{{
                getHumanTimeFor(subtitleLine.startTime)
              }} : </span>
          <span class="textSubtitle">{{ subtitleLine.text }}</span>
        </div>
      </div>
      <div class="footer"></div>
    </perfect-scrollbar>
    <div class="emptyState" v-if="showEmptyState">
      {{ $t('transcript.weet.empty') }}
      <br/>
      <div class="createTrancriptEmpty" v-if="canEditThisWeet">
        <GoToSubtitleWeetButton :weet="weet" size="small" color="outlined">
          {{ $t('transcript.create.new') }}
        </GoToSubtitleWeetButton>
      </div>
    </div>
    <div class="opaqueLayoutTop" v-if="!showEmptyState">

    </div>
    <div class="opaqueLayoutBottom" v-if="!showEmptyState">

    </div>

  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WToolTip from '@/components/wrapper/w-toolTip.vue';
import WIcon from '@/components/wrapper/w-icon.vue';
import {getUrlContent} from '@/utils/util';
// @ts-ignore
import srtParser from 'subtitles-parser';
import {
  canEditThisWeet,
  getHumanTime,
} from '@/utils/weetUtil';
import {Weet} from '@/store/weet/weetModel';
import UserAvatar from '@/components/user/UserAvatar.vue';
import store from '@/store';
import {PLAYER_PLAYING, SEEK_PLAYER, TIMER_PLAYER} from '@/store/timeLine/timeLineAction';
import WButton from '@/components/wrapper/w-button.vue';
import throttle from 'lodash/throttle';
import VueScrollTo from 'vue-scrollto';
import {SUBTITLE_LANG} from "@/store/persistedInformation/persistAction";
import WSelect from "@/components/wrapper/w-select.vue";
import GoToSubtitleWeetButton from "@/components/actionButton/GoToSubtitleWeetButton.vue";
import {clone} from "@/utils/cloneUtil";

@Component(
    {
      components: {GoToSubtitleWeetButton, WSelect, WButton, UserAvatar, WIcon, WToolTip},
    })
export default class SubtitleTextPanel extends Vue {
  // this is the result
  @Prop({default: ''})
  private weet!: Weet;

  private subtitleData: any[] = [];

  private subtitleDataReverse: any[] = [];


  private subtitleSelected: number = -1;

  private scrollDesactivate: boolean = false;

  private showEmptyState: boolean = false;

  private debouceScroll = throttle((timer: number) => {
    this.scrollToElement(timer);
  }, 1000);

  // subtitle
  public mounted() {
    if (this.weet.subtitles.length > 0) {
      this.provideSubtitleData();
    } else {
      this.showEmptyState = true;
    }

  }

  get timer(): number {
    return store.getters.getTimerPlayer;
  }

  public changeLang(value) {
    store.dispatch(SUBTITLE_LANG, value)
  }

  @Watch('timer')
  public changeSubtitleSelected() {
    for (const line of this.subtitleDataReverse) {
      // this is this line
      if (this.timer >= line.startTime && this.timer < line.endTime) {
        if (this.subtitleSelected !== line.startTime) {
          this.subtitleSelected = line.startTime;
          this.debouceScroll(this.subtitleSelected);
        }
        break;
      }
    }
  }

  get canEditThisWeet(): boolean {
    return canEditThisWeet(this.weet);
  }

  public classSubtitle(time: number): string {
    let classeCSS = 'subtitleMode';
    if (time === this.subtitleSelected) {
      classeCSS += ' selected';
    }
    return classeCSS;
  }

  get subtitleURL(): string {
    if (this.weet.subtitles.length > 0) {
      for (var sub of this.weet.subtitles) {
        if (sub.lang === this.subtitleLang) {
          return sub.url;
        }
      }
      return this.weet.subtitles[0].url
    } else {
      return "";
    }
  }

  get subtitleLang(): string {
    var lang = store.getters.getSubtitleLang;
    for (var sub of this.weet.subtitles) {
      if (sub.lang === lang) {
        return lang;
      }
    }
    if (this.weet.subtitles.length > 0) {
      return this.weet.subtitles[0].lang
    }
    return "";
  }

  @Watch('subtitleLang')
  public async provideSubtitleData() {
    if (this.subtitleURL) {
      const subtitleContent = await this.downloadSubtitle(this.subtitleURL);
      this.subtitleData = Object.freeze(srtParser.fromSrt(subtitleContent, true));
      this.subtitleDataReverse = clone(this.subtitleData).reverse();
    }
  }

  public async downloadSubtitle(subtitlePath: string) {
    return await getUrlContent(subtitlePath);
  }

  public getHumanTimeFor(time: number): string {
    return getHumanTime(time);
  }

  public setPlayerTime(time: number) {
    store.dispatch(SEEK_PLAYER, time).then(() => {
      store.dispatch(PLAYER_PLAYING, true);
    });
  }


  public scrollToElement(timer: number) {
    if (this.scrollDesactivate) {
      return;
    }

    // @ts-ignore
    const panel = this.$refs.scrollPanel.$el as HTMLDivElement;

    let el: any = this.$refs['subtitle_' + timer];
    if (el && el.length > 0) {
      el = el[0];
    }
    const options = {
      container: panel,
      easing: 'ease-in-out',
      lazy: true,
      offset: -100,
      force: false,
      cancelable: true,
      onStart: (element) => {
        // scrolling started
      },
      onDone: (element) => {
        // scrolling is done
      },
      onCancel: () => {
        // scrolling has been interrupted
      },
      x: false,
      y: true
    };
    // we have to wait the panel is open in fullscreenmode
    this.$nextTick(() => {
      VueScrollTo.scrollTo(el, 1000, options);
    });
  }
}
</script>

<style scoped lang="scss">
@import "@/scss/gridBreakPoint.scss";

.mainTranscritptContainer {
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 0px;
  text-align: left;
  height: 100%;
  position: relative;

  .avatarBox {
    display: flex;
    align-items: flex-start;
    width: 100%;
    position: relative;
    // height: 8px;
    margin-left: 8px;
    margin-top: 16px;

    .avatarTopLine {
      display: flex;
      margin-top: 8px;
      align-items: center;

      .avatarName {
        text-align: left;
        margin-left: 8px;
        color: var(--black);
        font-weight: 700;
        font-size: 14px;
      }

    }
  }

  .emptyState {
    margin-top: 16px;
    margin-left: 16px;
    min-height: 100px;
    text-align: center;

    .createTrancriptEmpty {
      text-align: center;
      margin-top: 16px;
    }
  }

  .transcriptLangContainer {
    margin-top: 16px;
    display: flex;
    width: 100%;

    .chooseLang {
      margin-left: 4px;
      flex: 1;
      margin-right: 16px;
    }
  }

  .blockTranscriptContainer {
    margin-left: 4px;
    margin-top: 16px;

    &.modeText {
      margin-left: 10px;
    }

    .subtitleElement {
      font-size: 14px;
      cursor: pointer;
      color: var(--black);
      letter-spacing: 0.2px;

      &.subtitleMode {
        display: flex;
        margin-top: 0px;
        padding: 4px;
        text-align: justify;

        &:hover {
          background: var(--light);
          border-radius: 8px;
        }
      }

      .timeBox {
        color: var(--black);
        font-weight: 600;
        font-size: 14px;
        min-width: 42px;
        margin-right: 8px;

      }


      &.selected {
        background: var(--light);
        font-weight: 800;
        letter-spacing: 0.0px;
        border-radius: 8px;
      }
    }
  }

  .opaqueLayoutTop {
    width: 100%;
    height: 12px;
    position: absolute;
    top: -4px;
    background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
  }

  .opaqueLayoutBottom {
    width: 100%;
    height: 30px;
    position: absolute;
    bottom: 0px;
    background: linear-gradient(rgba(255, 255, 255, 0.0), rgba(255, 255, 255, 1));
    @include GRID1X {
      display: none;
    }
    // background: red;
  }

  .ps {
    max-width: 400px;
    max-height: calc(100vh - 220px);
    padding-right: 16px;
    padding-left: 16px;
    padding-bottom: 32px;
    min-height: 320px;
    @include GRID1X {
      padding-right: 0px;
    }
  }

  .footer {
    height: 150px;
    background: rgba(0, 0, 0, 0);
  }
}

</style>
